import React, { useMemo } from 'react'

import { useLocation } from 'react-router-dom'
import { YStack, XStack } from 'tamagui'

import { Metadata } from '@newComponents/Metadata'
import { EmojiIcon } from '@newComponents/EmojiIcon/EmojiIcon'

import { GradientBackgroundScreen } from '@newComponents/Screen'
import { Card } from '@newComponents/Card'
import { H2, Paragraph, Text } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { SignUpScreenContent } from './SignUpScreenContent'

export const SignUpScreen = () => {
  const location = useLocation()

  const routerState = useMemo(
    () => ({
      state: {
        backgroundLocation: location.state?.backgroundLocation as
          | Location
          | undefined,
        authRedirectPath:
          (location.state?.authRedirectPath as string) || undefined,
      },
    }),
    [location]
  )

  return (
    <>
      <Metadata title='Sign Up' />

      <GradientBackgroundScreen alignItems='center'>
        <Card
          gap='$6'
          maxWidth={400}
          width='100%'
          borderRadius='$8'
          padding='$0'
          paddingTop='$7'
        >
          <YStack paddingHorizontal='$8' gap='$6'>
            <XStack gap='$6' alignItems='center'>
              <EmojiIcon size='$8' name='rocket' />

              <YStack gap='$1' flex={1}>
                <H2>Get started</H2>

                <Text size='$4' fontWeight='$3' color='$grey7'>
                  You're almost there
                </Text>
              </YStack>
            </XStack>

            <SignUpScreenContent />
          </YStack>

          <YStack
            backgroundColor='$lightBlue7'
            padding='$4'
            borderRadius={0}
            borderBottomLeftRadius='$8'
            borderBottomRightRadius='$8'
            alignItems='center'
            flex={1}
            width='100%'
          >
            <XStack gap='$2'>
              <Text size='$4' color='$grey0'>
                Already a user?
              </Text>

              <Link
                color='$grey0'
                size='$4'
                textDecorationLine='underline'
                href='/sign-in'
                options={routerState}
                hoverStyle={{
                  textDecorationLine: 'none',
                }}
              >
                Sign in
              </Link>
            </XStack>
          </YStack>
        </Card>
      </GradientBackgroundScreen>
    </>
  )
}

export default SignUpScreen
